import { useTabs as useTabsWeb } from '@react-aria/tabs';
import { mapDomPropsToRN } from '@react-native-aria/utils';
export function useTabs(props, state, ref) {
  const {
    tabListProps,
    tabPanelProps
  } = useTabsWeb(props, state, ref);
  return {
    tabListProps: mapDomPropsToRN(tabListProps),
    tabPanelProps: mapDomPropsToRN(tabPanelProps)
  };
}
//# sourceMappingURL=useTabs.web.js.map